// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__-2Yo7","productName":"Table_productName__3Wqsk"};